import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import cx from 'classnames';

import { useResponsive } from 'hooks/useResponsive';

import 'react-loading-skeleton/dist/skeleton.css';
import styles from './AiSearchSkeleton.module.scss';

export const SearchingSkeleton = ({ className }: { className?: string }) => {
  const screens = useResponsive();
  const fullRow = (
    <section className={styles.row}>
      <Skeleton
        count={1}
        height={14}
        borderRadius={6}
        containerClassName={styles.line100}
      />
    </section>
  );

  const row25 = (
    <section className={styles.row}>
      <Skeleton
        count={1}
        height={14}
        borderRadius={6}
        containerClassName={styles.line25}
      />
    </section>
  );

  const row66 = (
    <section className={styles.row}>
      <Skeleton
        count={1}
        height={14}
        borderRadius={6}
        containerClassName={styles.line66}
      />
    </section>
  );

  const row58 = (
    <section className={styles.row}>
      <Skeleton
        count={1}
        height={14}
        borderRadius={6}
        containerClassName={styles.line58}
      />
    </section>
  );

  return (
    <div className={cx(styles['search-loading-skeleton'], className)}>
      <SkeletonTheme baseColor="#dedede" highlightColor="#ececec">
        <section className={styles.rows}>
          {fullRow}
          {fullRow}
          {fullRow}
          {row25}
        </section>
        {screens.sm ? (
          <section className={styles.rows}>
            {fullRow}
            {fullRow}
            {fullRow}
            {row25}
          </section>
        ) : (
          <section className={styles.rows}>
            {row66}
            {row58}
            {fullRow}
            {row25}
          </section>
        )}
      </SkeletonTheme>
    </div>
  );
};

export const ChatLoadingSkeleton = ({ className }: { className?: string }) => {
  const fullRow = (
    <section className={styles.row}>
      <Skeleton
        count={1}
        height={14}
        borderRadius={6}
        containerClassName={styles.line100}
      />
    </section>
  );

  const row90 = (
    <section className={styles.row}>
      <Skeleton
        count={1}
        height={14}
        borderRadius={6}
        containerClassName={styles.line90}
      />
    </section>
  );

  const row33 = (
    <section className={styles.row}>
      <Skeleton
        count={1}
        height={14}
        borderRadius={6}
        containerClassName={styles.line33}
      />
    </section>
  );

  return (
    <div className={cx(styles['chat-loading-skeleton'], className)}>
      <SkeletonTheme baseColor="#dedede" highlightColor="#ececec">
        <section className={styles.rows}>
          {fullRow}
          {row90}
          {fullRow}
          {row33}
        </section>
      </SkeletonTheme>
    </div>
  );
};

export const OpportunityLoadingSkeleton = () => {
  return (
    <div className={styles['opportunity-loading-skeleton']}>
      <SkeletonTheme baseColor="#dedede" highlightColor="#ececec">
        <Skeleton circle={true} height={40} width={40} />
        <section className={styles.rows}>
          <div className={styles.row}>
            <Skeleton
              height={16}
              borderRadius={12}
              containerClassName={styles.line100}
            />
          </div>
          <div className={styles.row}>
            <Skeleton
              height={16}
              borderRadius={12}
              containerClassName={styles.line33}
            />
          </div>
          <div className={styles.row}>
            <Skeleton
              height={10}
              borderRadius={12}
              containerClassName={styles.line20}
            />
            <Skeleton
              height={10}
              borderRadius={12}
              containerClassName={styles.line10}
            />
          </div>
          <div className={styles.row}>
            <Skeleton
              height={24}
              borderRadius={12}
              containerClassName={styles.line15}
            />
            <Skeleton
              height={24}
              borderRadius={12}
              containerClassName={styles.line15}
            />
          </div>
        </section>
      </SkeletonTheme>
    </div>
  );
};

export const OpportunityLoadingSkeleton2 = () => {
  return (
    <div className={styles['opportunity-loading-skeleton']}>
      <SkeletonTheme baseColor="#dedede" highlightColor="#ececec">
        <Skeleton circle={true} height={40} width={40} />
        <section className={styles.rows}>
          <div className={styles.row}>
            <Skeleton
              height={16}
              borderRadius={12}
              containerClassName={styles.line100}
            />
          </div>
          <div className={styles.row}>
            <Skeleton
              height={16}
              borderRadius={12}
              containerClassName={styles.line50}
            />
          </div>
          <div className={styles.row}>
            <Skeleton
              height={10}
              borderRadius={12}
              containerClassName={styles.line20}
            />
            <Skeleton
              height={10}
              borderRadius={12}
              containerClassName={styles.line10}
            />
          </div>
        </section>
      </SkeletonTheme>
    </div>
  );
};

export const OpportunitiesLoadingSkeleton = () => {
  return (
    <div className={styles['opportunities-loading-skeleton']}>
      <OpportunityLoadingSkeleton />
      <OpportunityLoadingSkeleton />
      <OpportunityLoadingSkeleton2 />
      <OpportunityLoadingSkeleton2 />
      <OpportunityLoadingSkeleton />
      <OpportunityLoadingSkeleton />
      <OpportunityLoadingSkeleton2 />
      <OpportunityLoadingSkeleton />
      <OpportunityLoadingSkeleton />
    </div>
  );
};
